<template>
  <div class="user">
    <div class="photo" style="box-shadow: none">
      <!--      <img :src="'./img/default-avatar.png'" alt="avatar" />-->
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link :to="{ name: 'ProfileUser' }">
                  <md-icon>account_circle</md-icon>
                  <span class="sidebar-normal">{{
                    $t("menu.my_profile")
                  }}</span>
                </router-link>
              </li>
              <li>
                <a href="javascript:void(0)" @click="logout()">
                  <md-icon>logout</md-icon>
                  <span class="sidebar-normal">{{ $t("menu.logout") }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { AuthService } from "../../../../services/auth.service";
import $router from "../../../../router";

export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: "User"
    },
    avatar: {
      type: String,
      default: "./img/faces/avatar.jpg"
    }
  },
  data() {
    return {
      isClosed: true
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    async logout() {
      await this.$router.push({ name: "Login" });
      await AuthService.logout();
      this.$notify({
        title: this.$t("common.success"),
        text: this.$t("auth.logout_successfully"),
        type: "success"
      });
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
